import React, { useEffect, useState, Suspense, lazy, useContext, useRef } from 'react';
import uuid from 'react-uuid';
import moment from 'moment-timezone';

import { useDispatch, useSelector } from 'react-redux';
import { activeCita, startSaveCita } from '../../../actions/citas';
import { activeUsuario } from '../../../actions/usuarios';
import { activeServicio } from '../../../actions/servicios';
import { activeSucursal } from '../../../actions/sucursales';
import { activeProfesional } from '../../../actions/profesionales';
import { SocketContext } from '../../../context/SocketContext';
import { closeLoading, openLoading } from '../../../actions/ui';
import { YlmModalTwoButtons } from '../../../components/main/YlmModalTwoButtons';
const DailyCalendarItem = lazy(async () => (await import('./DailyCalendarItem')));

const timezone = process.env.REACT_APP_TIMEZONE;
const usarSockets = process.env.REACT_SOCKETS;

export const DailyCalendar = ({ dailyItem, viewValue, editCita, setEditCita, activeDnd, setActiveDnd, selectedDate, targetCitaId, setTargetCitaId, setActiveModalReserva }) => {

    const dispatch = useDispatch();
    const citaActive = useSelector(state => state.citas.active);
    const { uid } = useSelector(state => state.auth);
    const { empresas } = useSelector(state => state.empresas);
    const { socket } = useContext(SocketContext);
    const [espaciadoEmpresa, setEspaciadoEmpresa] = useState(5);
    const [franjas, setFranjas] = useState([]);
    const [altoFranja, setAltoFranja] = useState(0);
    const [altoFranjaCita, setAltoFranjaCita] = useState(0);
    const [altoFranjaDraggable, setAltoFranjaDraggable] = useState(espaciadoEmpresa * 2.5);
    const { variantes } = useSelector(state => state.variantes);
    const { servicios } = useSelector(state => state.servicios);

    const [dataModal, setDataModal] = useState({
        title: '¿Modificar cita?',
        text: ['¿Estás seguro de modificar esta cita?'],
        buttonText: 'Estoy seguro',
        button2Text: 'Cancelar'
    });
    const [modalTwoButtonsOpened, setModalTwoButtonsOpened] = useState(false);
    const [modalResponse, setModalResponse] = useState(100);
    const [modalWaiting, setModalWaiting] = useState({});

    const [over, setOver] = useState(false);
    const [scrollPosition, setScrollPosition] = useState(false);

    const vistaCalendario = useRef(null);
    const citasViewRef = useRef(null);

    const horario = ['8', '9', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21'];

    const [cuadrante, setCuadrante] = useState([]);

    useEffect(() => {
        if (espaciadoEmpresa > 0) {
            setAltoFranja(espaciadoEmpresa * 2.5);
            setAltoFranjaCita(espaciadoEmpresa * 2.5);
        }
    }, [espaciadoEmpresa])

    useEffect(() => {
        let newFranjas = [];
        for (let i = 0; i < 60; i = i + espaciadoEmpresa) {
            let nombreFranja = i.toString();
            if (nombreFranja.length < 2) {
                nombreFranja = '0' + nombreFranja;
            }
            newFranjas = [...newFranjas, nombreFranja];
        }
        setFranjas(newFranjas);
    }, [espaciadoEmpresa]);


    useEffect(() => {
        if (dailyItem) {
            generaCuadrante();
            if (scrollPosition && vistaCalendario.current && !targetCitaId && viewValue !== 'today') {
                vistaCalendario.current.scrollTop = scrollPosition;
            }
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dailyItem, franjas]);

    useEffect(() => {
        if (targetCitaId && dailyItem && setTargetCitaId) {
            const timer = setTimeout(() => {
                setTargetCitaId(null);
            }, 500);

            return () => clearTimeout(timer);
        }
    }, [targetCitaId, dailyItem, setTargetCitaId]);

    useEffect(() => {
        if (dailyItem && vistaCalendario.current && (viewValue === 'day' || viewValue === 'today') && !targetCitaId) {
            setScrollPosition(false);

            setTimeout(() => {
                if (vistaCalendario.current) {
                    scrollToCurrentTime(0);
                }
            }, 300);
        }
    }, [viewValue]);

    useEffect(() => {
        if (modalWaiting.reserva) {
            if (modalResponse === 1) {
                dispatch(startSaveCita(modalWaiting.reserva));
                if (modalWaiting.reservaRelacionada) {
                    dispatch(startSaveCita(modalWaiting.reservaRelacionada));
                }
            }
            setModalWaiting({});
            setModalResponse(100);
            dispatch(closeLoading());
        } else {
            if (modalWaiting._id) {
                if (modalResponse === 1) {
                    dispatch(startSaveCita(modalWaiting));
                }
                setModalWaiting({});
                setModalResponse(100);
                dispatch(closeLoading());
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [modalResponse]);

    const handleScroll = (event) => {
        if (viewValue !== 'today') {
            setScrollPosition(event.target.scrollTop);
        }
    }

    const generaCuadrante = () => {
        let newColumns = [];
        let initialScrollPoint = -15;
        dailyItem.calendarItems.forEach((calendarItem, currentColumn) => {
            if (calendarItem.items[0]?.profSelected && calendarItem.items[0]?.sucursalSelected) {
                let newFranjas = [];
                let currentTop = 0;
                horario.map((hora) => {
                    currentTop += 1; // compensar border-top de .horario-diario
                    const horaDosCifras = (hora.length < 2) ? `0${hora}` : hora;
                    let huecoAvailable = 0;
                    franjas.map((minutos, idxFranja) => {
                        const newItem = {
                            empty: true,
                            available: huecoAvailable <= 0,
                            idProfesional: null,
                            currentColumn,
                            idx: idxFranja,
                            currentTop
                        }
                        calendarItem.items.forEach((item, idx) => {
                            const serviciosAUsar = item.serviciosDelProfesional ||
                                (item.cita.servicios && Array.isArray(item.cita.servicios) && item.cita.servicios.length > 0
                                    ? item.cita.servicios
                                    : null);

                            if (serviciosAUsar && serviciosAUsar.length > 0) {
                                serviciosAUsar.forEach((servicioDetalle, idxServicio) => {
                                    const fechaInicioServicio = moment.tz(servicioDetalle.fechaInicio, timezone);
                                    const horaInicioServicio = fechaInicioServicio.hour();
                                    const minutosInicioServicio = fechaInicioServicio.minute();
                                    const horaInicioServicioStr = horaInicioServicio.toString().padStart(2, '0');
                                    const minutosInicioServicioStr = minutosInicioServicio.toString().padStart(2, '0');

                                    const coincide = horaInicioServicioStr === horaDosCifras && minutosInicioServicioStr === minutos;
                                    if (coincide) {
                                        const duracionServicio = servicioDetalle.duracion || parseInt(item.cita.duracion);

                                        const horaInicio = 8;
                                        const horasDesdeInicio = horaInicioServicio - horaInicio;
                                        const minutosDesdeInicio = horasDesdeInicio * 60 + minutosInicioServicio;
                                        const servicioCurrentTop = (minutosDesdeInicio / espaciadoEmpresa) * (espaciadoEmpresa * 2.5 + espaciadoEmpresa / 60);

                                        const idxServicioOriginal = servicioDetalle.idxServicio !== undefined
                                            ? servicioDetalle.idxServicio
                                            : idxServicio;

                                        const profDelServicio = servicioDetalle.profesional;
                                        const idProfesionalServicio = (typeof profDelServicio === 'object' && profDelServicio?._id)
                                            ? profDelServicio._id.toString()
                                            : (profDelServicio?.toString() || item.cita.profesional?._id?.toString());

                                        const servicioItem = {
                                            empty: false,
                                            available: false,
                                            idProfesional: idProfesionalServicio,
                                            currentColumn,
                                            idx: idxFranja,
                                            currentTop: servicioCurrentTop,
                                            hora: `${fechaInicioServicio.format('H:mm')}`,
                                            horaFin: `${fechaInicioServicio.clone().add(duracionServicio, 'minutes').format('H:mm')}`,
                                            duracion: duracionServicio,
                                            idxProf: item.idxProf,
                                            cita: {
                                                ...item.cita,
                                                servicioActual: servicioDetalle,
                                                idxServicio: idxServicioOriginal
                                            },
                                            time: `${horaDosCifras}:${minutos}`
                                        };

                                        if (initialScrollPoint === -15 || initialScrollPoint > servicioItem.currentTop) {
                                            initialScrollPoint = servicioItem.currentTop;
                                        }

                                        newFranjas = [
                                            ...newFranjas,
                                            servicioItem
                                        ];

                                        huecoAvailable = duracionServicio / espaciadoEmpresa - 1;
                                    }
                                });
                            } else {
                                const fechaCita = moment.tz(item.fecha, timezone);
                                const horaInicioCita = fechaCita.hour();
                                const minutosInicioCita = fechaCita.minute();
                                const horaInicioCitaStr = horaInicioCita.toString().padStart(2, '0');
                                const minutosInicioCitaStr = minutosInicioCita.toString().padStart(2, '0');

                                if (horaInicioCitaStr === horaDosCifras && minutosInicioCitaStr === minutos) {
                                    const profesionalDelay = parseInt(item.cita.profesionalDelay);
                                    const usuarioDelay = parseInt(item.cita.usuarioDelay);
                                    const duracionCita = parseInt(item.cita.duracion) + profesionalDelay + usuarioDelay;

                                    const horaInicio = 8;
                                    const horasDesdeInicio = horaInicioCita - horaInicio;
                                    const minutosDesdeInicio = horasDesdeInicio * 60 + minutosInicioCita;
                                    const citaCurrentTop = (minutosDesdeInicio / espaciadoEmpresa) * (espaciadoEmpresa * 2.5 + espaciadoEmpresa / 60);

                                    const citaItem = {
                                        empty: false,
                                        available: false,
                                        idProfesional: item.cita.profesional?._id?.toString(),
                                        currentColumn,
                                        idx: idxFranja,
                                        currentTop: citaCurrentTop,
                                        hora: `${fechaCita.format('H:mm')}`,
                                        horaFin: `${fechaCita.clone().add(duracionCita, 'minutes').format('H:mm')}`,
                                        duracion: duracionCita,
                                        idxProf: item.idxProf,
                                        cita: item.cita,
                                        time: `${horaDosCifras}:${minutos}`
                                    };

                                    if (initialScrollPoint === -15 || initialScrollPoint > citaItem.currentTop) {
                                        initialScrollPoint = citaItem.currentTop;
                                    }

                                    newFranjas = [
                                        ...newFranjas,
                                        citaItem
                                    ];

                                    huecoAvailable = duracionCita / espaciadoEmpresa - 1;
                                }
                            }
                            if (item) {
                                newItem.idProfesional = item.cita.profesional?._id;
                            }

                        });
                        if (newItem.empty && huecoAvailable > 0) {
                            huecoAvailable--;
                        }
                        newItem.time = `${horaDosCifras}:${minutos}`;
                        if (!newItem.empty) {
                            if (initialScrollPoint === -15 || initialScrollPoint > newItem.currentTop) {
                                initialScrollPoint = newItem.currentTop;
                            }

                            newFranjas = [
                                ...newFranjas,
                                newItem
                            ]
                        }
                        currentTop += espaciadoEmpresa * 2.5;
                        return minutos;
                    });
                    return hora;
                });
                newColumns = [
                    ...newColumns,
                    newFranjas
                ]
            }
        });
        const scrollValue = initialScrollPoint === -15 ? 0 : initialScrollPoint;
        scrollToCurrentTime(scrollValue);
        setCuadrante(newColumns);
    };

    const scrollToCurrentTime = (value) => {
        const isToday = selectedDate && selectedDate.format('D-M-YYYY') === moment().format('D-M-YYYY');

        if (vistaCalendario.current) {
            let scrollFinal = 0;
            let shouldScroll = false;

            if (targetCitaId && dailyItem) {
                if (targetCitaId === 'first') {
                    if (viewValue === 'day' && value) {
                        scrollFinal = value;
                        shouldScroll = true;
                    }
                } else {
                    let targetCitaFound = false;
                    dailyItem.calendarItems.forEach(columna => {
                        columna.items.forEach(item => {
                            if (item.cita._id === targetCitaId && !targetCitaFound) {
                                const citaTime = moment.tz(item.fecha, timezone);
                                const horaInicio = 8;
                                const horasDesdeInicio = citaTime.hour() - horaInicio;
                                const minutosDesdeInicio = horasDesdeInicio * 60 + citaTime.minute();

                                scrollFinal = (minutosDesdeInicio / 5) * (espaciadoEmpresa * 2.5);
                                targetCitaFound = true;
                                shouldScroll = true;
                            }
                        });
                    });
                    if (!targetCitaFound && viewValue === 'day' && value) {
                        scrollFinal = value;
                        shouldScroll = true;
                    }
                }
            }
            else if (viewValue === 'today' && isToday) {
                const horaActual = moment().hour();
                const minutosActuales = moment().minute();

                const horaInicio = 8;
                const horasDesdeInicio = horaActual - horaInicio;
                const minutosDesdeInicio = horasDesdeInicio * 60 + minutosActuales;

                const posicionEnPixeles = (minutosDesdeInicio / 5) * (espaciadoEmpresa * 2.5);
                scrollFinal = posicionEnPixeles;
                shouldScroll = true;
            }
            else if (viewValue === 'day') {
                scrollFinal = 0;
                shouldScroll = true;
            }

            if (shouldScroll && vistaCalendario.current) {
                const maxScroll = vistaCalendario.current.scrollHeight - vistaCalendario.current.clientHeight;
                scrollFinal = Math.min(scrollFinal, maxScroll);
                scrollFinal = Math.max(0, scrollFinal);
                vistaCalendario.current.scrollTo(0, scrollFinal);
            }
        }
    }

    const onClickCita = ({ cita: clickPayload }) => {
        const clickedId = clickPayload?.cita?._id || clickPayload?._id;
        const isMismaCita = citaActive?._id && String(citaActive._id) === String(clickedId);
        const ensureServicioDetalleActual = (cita) => {
            if (!cita?.servicios?.length || cita.servicios.length <= 1 || cita.servicioActual) return cita;
            const primeroNoPagado = cita.servicios.find(sd => !sd.pagada);
            const detalle = primeroNoPagado || cita.servicios[0];
            return { ...cita, servicioActual: detalle };
        };
        const resolvedPayload = clickPayload?.cita != null ? clickPayload.cita : clickPayload;
        const citaToActivate = ensureServicioDetalleActual(resolvedPayload);
        const esMultiservicio = citaToActivate?.servicios?.length > 1;
        const slotClicado = resolvedPayload?.servicioActual;
        const esOtroBloque = esMultiservicio && slotClicado && citaActive?.servicioActual
            && String(slotClicado?.fechaInicio || '') !== String(citaActive.servicioActual?.fechaInicio || '');
        if (!editCita) {
            const id = citaToActivate._id;
            dispatch(activeCita(id, citaToActivate));
            dispatch(activeUsuario(citaToActivate.usuario?._id, citaToActivate.usuario));
            dispatch(activeServicio(citaToActivate.servicios?.[0]?.servicio || citaToActivate.servicios?.[0]?._id, citaToActivate.servicios?.[0]));
            dispatch(activeSucursal(citaToActivate.sucursal?._id, citaToActivate.sucursal));
            const profesionalSlot = citaToActivate.servicioActual?.profesional;
            const profesionalId = profesionalSlot != null
                ? (typeof profesionalSlot === 'object' ? (profesionalSlot._id || profesionalSlot) : profesionalSlot)
                : (citaToActivate.profesional?._id || citaToActivate.profesional);
            const profesionalObj = typeof profesionalSlot === 'object' && profesionalSlot?.nombre
                ? profesionalSlot
                : citaToActivate.profesional;
            dispatch(activeProfesional(profesionalId, profesionalObj));
            setEditCita(true);
            setActiveDnd(false);
            if (typeof setActiveModalReserva === 'function') setActiveModalReserva(true);
        } else if (isMismaCita && typeof setActiveModalReserva === 'function') {
            if (esOtroBloque) {
                const citaConBloqueClicado = { ...citaActive, servicioActual: slotClicado };
                dispatch(activeCita(citaActive._id, citaConBloqueClicado));
                const profesionalSlot = slotClicado?.profesional;
                const profesionalId = profesionalSlot != null
                    ? (typeof profesionalSlot === 'object' ? (profesionalSlot._id || profesionalSlot) : profesionalSlot)
                    : (citaActive.profesional?._id || citaActive.profesional);
                const profesionalObj = typeof profesionalSlot === 'object' && profesionalSlot?.nombre
                    ? profesionalSlot
                    : citaActive.profesional;
                dispatch(activeProfesional(profesionalId, profesionalObj));
            }
            setActiveModalReserva(true);
        } else if (!isMismaCita && typeof setActiveModalReserva === 'function') {
            const citaToActivate = ensureServicioDetalleActual(clickPayload.cita != null ? clickPayload.cita : clickPayload);
            const id = citaToActivate._id;
            dispatch(activeCita(id, citaToActivate));
            dispatch(activeUsuario(citaToActivate.usuario?._id, citaToActivate.usuario));
            dispatch(activeServicio(citaToActivate.servicios?.[0]?.servicio || citaToActivate.servicios?.[0]?._id, citaToActivate.servicios?.[0]));
            dispatch(activeSucursal(citaToActivate.sucursal?._id, citaToActivate.sucursal));
            const profesionalSlot = citaToActivate.servicioActual?.profesional;
            const profesionalId = profesionalSlot != null
                ? (typeof profesionalSlot === 'object' ? (profesionalSlot._id || profesionalSlot) : profesionalSlot)
                : (citaToActivate.profesional?._id || citaToActivate.profesional);
            const profesionalObj = typeof profesionalSlot === 'object' && profesionalSlot?.nombre
                ? profesionalSlot
                : citaToActivate.profesional;
            dispatch(activeProfesional(profesionalId, profesionalObj));
            setActiveDnd(false);
            setActiveModalReserva(true);
        }
    }

    const twoDecimals = (number) => {
        return parseFloat(parseFloat(number).toFixed(2));
    }

    const getTargetColumn = (sourceColumn, deltaX) => {
        if (!citasViewRef.current || cuadrante.length <= 1) return sourceColumn;
        const columnWidth = citasViewRef.current.offsetWidth / cuadrante.length;
        const targetCol = sourceColumn + Math.round(deltaX / columnWidth);
        return Math.max(0, Math.min(targetCol, cuadrante.length - 1));
    };

    const getProfesionalForColumn = (columnIndex) => {
        let visibleIdx = 0;
        for (let i = 0; i < dailyItem.calendarItems.length; i++) {
            const calItem = dailyItem.calendarItems[i];
            if (calItem.items[0]?.profSelected && calItem.items[0]?.sucursalSelected) {
                if (visibleIdx === columnIndex) {
                    return calItem.items[0]?.cita?.profesional?._id;
                }
                visibleIdx++;
            }
        }
        return null;
    };

    const clearDragHighlight = () => {
        if (!citasViewRef.current) return;
        citasViewRef.current.querySelectorAll('.daily-column').forEach(col => {
            col.classList.remove('drag-target');
        });
    };

    const handleDragParent = (ev, ui) => {
        if (!citasViewRef.current) return;
        const sourceVisibleColumn = parseInt(ui.node.getAttribute('data-visible-column')) ?? parseInt(ui.node.getAttribute('data-column'));
        const targetCol = getTargetColumn(sourceVisibleColumn, ui.x);
        const cols = citasViewRef.current.querySelectorAll('.daily-column');
        cols.forEach((col, idx) => {
            if (idx === targetCol) {
                col.classList.add('drag-target');
            } else {
                col.classList.remove('drag-target');
            }
        });
    };

    const handleStart = (ev, ui) => {
    }

    const handleEvent = (ev, ui) => {
        const idColumna = parseInt(ui.node.getAttribute('data-column'));
        let peticionAprobada = true;

        if (ui.lastY !== 0 || ui.lastX !== 0) {
            const sourceVisibleColumn = parseInt(ui.node.getAttribute('data-visible-column')) ?? idColumna;
            const targetColumn = getTargetColumn(sourceVisibleColumn, ui.lastX);
            const isCrossColumn = targetColumn !== sourceVisibleColumn;

            const citaId = ui.node.getAttribute('data-_id');
            const duracion = parseInt(ui.node.getAttribute('data-duracion'));
            const posicionSolicitadaInicio = twoDecimals(parseFloat(ui.node.dataset.top) + parseFloat(ui.lastY));
            const posicionSolicitadaFin = twoDecimals(duracion * (altoFranjaDraggable / espaciadoEmpresa) + posicionSolicitadaInicio);
            const diferencia = (parseFloat(ui.lastY) / altoFranjaDraggable) * espaciadoEmpresa;

            let citaActual = null;
            let citaRelacionada = null;
            let citaRelacionadaColumn = null;

            dailyItem.calendarItems.forEach(columna => {
                columna.items.forEach(item => {
                    if (item.cita._id === citaId) {
                        citaActual = item.cita;
                    }
                });
            });

            if (citaActual?.citaRelacionada) {
                let visibleCol = 0;
                dailyItem.calendarItems.forEach(columna => {
                    if (columna.items[0]?.profSelected && columna.items[0]?.sucursalSelected) {
                        columna.items.forEach(item => {
                            if (item.cita._id === citaActual.citaRelacionada) {
                                citaRelacionada = item.cita;
                                citaRelacionadaColumn = visibleCol;
                            }
                        });
                        visibleCol++;
                    }
                });
            }

            if (!citaActual) {
                clearDragHighlight();
                setActiveDnd(false);
                return;
            }

            const relacionadaEnMismaColumna = citaRelacionada && citaRelacionadaColumn === sourceVisibleColumn;
            const targetColumnRelacionada = relacionadaEnMismaColumna ? targetColumn : citaRelacionadaColumn;

            cuadrante.forEach((columna, visibleColIdx) => {
                columna.forEach(item => {
                    if (item.cita._id !== citaId && item.cita._id !== citaActual?.citaRelacionada) {
                        const citaInicio = twoDecimals(item.currentTop);
                        const citaFin = twoDecimals(item.duracion * (altoFranjaDraggable / espaciadoEmpresa) + item.currentTop);

                        if (visibleColIdx === targetColumn) {
                            if ((posicionSolicitadaInicio >= citaInicio && posicionSolicitadaInicio < citaFin) ||
                                (posicionSolicitadaFin > citaInicio && posicionSolicitadaFin <= citaFin)) {
                                peticionAprobada = false;
                            }
                        }

                        if (citaRelacionada) {
                            const diferenciaTiempo = moment(citaRelacionada.fecha).diff(moment(citaActual.fecha), 'minutes');
                            const posicionRelacionadaInicio = posicionSolicitadaInicio +
                                (diferenciaTiempo * (altoFranjaDraggable / espaciadoEmpresa));
                            const posicionRelacionadaFin = posicionRelacionadaInicio +
                                (citaRelacionada.duracion * (altoFranjaDraggable / espaciadoEmpresa));

                            if (visibleColIdx === targetColumnRelacionada) {
                                if ((posicionRelacionadaInicio >= citaInicio && posicionRelacionadaInicio < citaFin) ||
                                    (posicionRelacionadaFin > citaInicio && posicionRelacionadaFin <= citaFin)) {
                                    peticionAprobada = false;
                                }
                            }
                        }
                    }
                });
            });

            if (peticionAprobada) {
                dispatch(openLoading());

                const newFecha = diferencia > 0
                    ? moment(citaActual.fecha).add(Math.abs(diferencia), 'minutes')
                    : moment(citaActual.fecha).subtract(Math.abs(diferencia), 'minutes');

                const newProfesionalId = isCrossColumn ? getProfesionalForColumn(targetColumn) : (citaActual.profesional?._id || citaActual.profesional);

                let serviciosActualizados = null;
                if (citaActual.servicios && Array.isArray(citaActual.servicios) && citaActual.servicios.length > 0) {
                    serviciosActualizados = citaActual.servicios.map(servicioDetalle => ({
                        ...servicioDetalle,
                        profesional: isCrossColumn ? newProfesionalId : (servicioDetalle.profesional?._id || servicioDetalle.profesional),
                        servicio: servicioDetalle.servicio?._id || servicioDetalle.servicio,
                        fechaInicio: diferencia > 0
                            ? moment(servicioDetalle.fechaInicio).add(Math.abs(diferencia), 'minutes').toDate()
                            : moment(servicioDetalle.fechaInicio).subtract(Math.abs(diferencia), 'minutes').toDate()
                    }));
                }

                const reserva = {
                    _id: citaActual._id,
                    fecha: newFecha.toISOString(),
                    internal: true,
                    usuario: citaActual.usuario?._id || citaActual.usuario,
                    profesional: newProfesionalId,
                    empresa: citaActual.empresa?._id || citaActual.empresa,
                    sucursal: citaActual.sucursal?._id || citaActual.sucursal,
                    servicios: serviciosActualizados || citaActual.servicios || [],
                    variantes: citaActual.variantes || [],
                    duracion: citaActual.duracion,
                    precio: citaActual.precio,
                    estado: citaActual.estado,
                    recordatorios: citaActual.recordatorios,
                };

                if (citaRelacionada) {
                    const diferenciaTiempo = moment(citaRelacionada.fecha).diff(moment(citaActual.fecha), 'minutes');
                    const newFechaRelacionada = moment(newFecha).add(diferenciaTiempo, 'minutes');

                    const newProfRelacionada = relacionadaEnMismaColumna && isCrossColumn
                        ? getProfesionalForColumn(targetColumn)
                        : (citaRelacionada.profesional?._id || citaRelacionada.profesional);

                    let serviciosRelacionadaActualizados = null;
                    if (citaRelacionada.servicios && Array.isArray(citaRelacionada.servicios) && citaRelacionada.servicios.length > 0) {
                        serviciosRelacionadaActualizados = citaRelacionada.servicios.map(servicioDetalle => ({
                            ...servicioDetalle,
                            profesional: (relacionadaEnMismaColumna && isCrossColumn) ? newProfRelacionada : (servicioDetalle.profesional?._id || servicioDetalle.profesional),
                            servicio: servicioDetalle.servicio?._id || servicioDetalle.servicio,
                            fechaInicio: diferencia > 0
                                ? moment(servicioDetalle.fechaInicio).add(Math.abs(diferencia), 'minutes').toDate()
                                : moment(servicioDetalle.fechaInicio).subtract(Math.abs(diferencia), 'minutes').toDate()
                        }));
                    }

                    

                    const reservaRelacionada = {
                        _id: citaRelacionada._id,
                        fecha: newFechaRelacionada.toISOString(),
                        internal: true,
                        usuario: citaRelacionada.usuario?._id || citaRelacionada.usuario,
                        profesional: newProfRelacionada,
                        empresa: citaRelacionada.empresa?._id || citaRelacionada.empresa,
                        sucursal: citaRelacionada.sucursal?._id || citaRelacionada.sucursal,
                        servicios: serviciosRelacionadaActualizados || citaRelacionada.servicios || [],
                        variantes: citaRelacionada.variantes || [],
                        duracion: citaRelacionada.duracion,
                        precio: citaRelacionada.precio,
                        estado: citaRelacionada.estado,
                        recordatorios: citaRelacionada.recordatorios,
                    };

                    if (usarSockets) {
                        socket?.emit('grabar-cita', {
                            uid,
                            reserva,
                            reservaRelacionada,
                            internal: true
                        });
                    } else {
                        setDataModal({
                            title: '¿Modificar citas?',
                            text: ['¿Estás seguro de modificar estas citas relacionadas?'],
                            buttonText: 'Estoy seguro',
                            button2Text: 'Cancelar'
                        });

                        setModalWaiting({ reserva, reservaRelacionada });
                        setModalTwoButtonsOpened(true);
                    }
                } else {
                    if (usarSockets) {
                        socket?.emit('grabar-cita', { uid, reserva, internal: true });
                    } else {
                        setDataModal({
                            title: '¿Modificar cita?',
                            text: ['¿Estás seguro de modificar esta cita?'],
                            buttonText: 'Estoy seguro',
                            button2Text: 'Cancelar'
                        });
                        setModalWaiting(reserva);
                        setModalTwoButtonsOpened(true);
                    }
                }
            } else {
                generaCuadrante();
            }
        }

        clearDragHighlight();
        setActiveDnd(false);
    };

    return (
        <>
            {
                ((viewValue === 'day' || viewValue === 'today') && altoFranja > 0)
                &&
                <div
                    className={`daily-view`}
                    ref={vistaCalendario}
                    onScroll={handleScroll}
                >
                    {
                        horario.map((hora, idx) => (
                            <div key={uuid()} className={`horario-diario ${(idx === (horario.length - 1)) ? 'ultimo' : ''}`}>
                                <div className="hora">{`${hora} h`}</div>
                                <div key={uuid()}
                                    className="franjas"
                                >
                                    {
                                        franjas.map(minuto => (
                                            <div
                                                key={uuid()}
                                                className={`franja ${minuto === '00' ? 'franja-hora' : ''}`}
                                                style={{
                                                    height: altoFranja,
                                                }}
                                            >{hora.padStart(2, '0')}:{minuto}</div>
                                        ))
                                    }
                                </div>
                            </div>
                        ))
                    }
                    <div className="citas-view columns" ref={citasViewRef}>
                        <Suspense fallback={<p>Cargando...</p>}>
                            {
                                cuadrante?.map((column, idxColumn) => (
                                    <div
                                        key={uuid()}
                                        className={`daily-column size-${cuadrante.length}`}
                                    >
                                        {
                                            column.map((cita, idxCita) => (
                                                (cita.idxProf)
                                                    ?
                                                    <div
                                                        key={uuid()}
                                                        className='franja-item'
                                                        style={{
                                                            position: 'absolute',
                                                            top: `${cita.currentTop}px`,
                                                            width: '100%'
                                                        }}
                                                    >
                                                        <DailyCalendarItem
                                                            altoFranjaDraggable={altoFranjaDraggable}
                                                            handleEvent={handleEvent}
                                                            handleStart={handleStart}
                                                            onClickCita={onClickCita}
                                                            espaciadoEmpresa={espaciadoEmpresa}
                                                            cita={cita}
                                                            index={idxCita + (10000 * idxColumn)}
                                                            activeDnd={activeDnd}
                                                            handleDragParent={handleDragParent}
                                                            visibleColumnIndex={idxColumn}
                                                        />
                                                    </div>
                                                    :
                                                    <div
                                                        key={uuid()}
                                                        className='franja-item'
                                                        style={{
                                                            height: altoFranjaCita
                                                        }}
                                                    >
                                                    </div>
                                            )
                                            )
                                        }
                                    </div>
                                ))
                            }
                        </Suspense>
                    </div>

                    <YlmModalTwoButtons
                        data={dataModal}
                        setModalResponse={setModalResponse}
                        modalTwoButtonsOpened={modalTwoButtonsOpened}
                        setModalTwoButtonsOpened={setModalTwoButtonsOpened}
                    />
                </div>
            }
        </>
    )
}
